"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const address_schema_1 = require("@Entities/schemas/common/address-schema");
const InnerForm_1 = __importDefault(require("@Fields/v2/InnerForm"));
const MailingAddress_1 = __importDefault(require("@Fields/v2/MailingAddress"));
const AddressSection = (props) => {
    const extendedAddressForm = props.extendedAddressForm;
    const { city, state, countryId, postalCode, address2, address3, address4 } = extendedAddressForm;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("section", { className: 'mailing-address-section' },
            react_1.default.createElement("h5", null, "Mailing Address"),
            react_1.default.createElement("div", { className: 'fields-column-container custom' },
                react_1.default.createElement(InnerForm_1.default, { formFields: { address2, address3, address4 } }))),
        react_1.default.createElement("section", { className: 'address-section' },
            react_1.default.createElement("div", { className: 'fields-row-container' },
                react_1.default.createElement(MailingAddress_1.default, { addressFormFields: { city, countryId, state, postalCode }, title: 'Address', formKey: address_schema_1.extendedAddressFormKey })))));
};
exports.default = AddressSection;
